export default "__VITE_ASSET__mKud1HyC__"